export default __webpack_public_path__ + "static/media/Foto21.94aa5ad1.png";